import { render, staticRenderFns } from "./CalculationOverview.vue?vue&type=template&id=8df24dc8"
import script from "./CalculationOverview.vue?vue&type=script&lang=js"
export * from "./CalculationOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports